import { OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";

import { JurisdictionTranslatePrefix } from "../jurisdiction.model";

import { JurisdictionPrefixService } from "./jurisdiction-prefix.service";

@Pipe({
	name: "jurisdiction",
})
export class JurisdictionPrefixPipe implements OnDestroy, PipeTransform {
	private prefix = "";
	private readonly prefix$$: Subscription;

	constructor(
		private service: JurisdictionPrefixService,
		private translateService: TranslateService
	) {
		this.prefix$$ = this.service
			.getJurisdictionPrefix$()
			.subscribe((jurisdictionPrefix) => (this.prefix = jurisdictionPrefix));
	}

	ngOnDestroy() {
		this.prefix$$?.unsubscribe();
	}

	transform(value: string): string {
		const prefixedKey = this.prefix === JurisdictionTranslatePrefix.Mga ? value : `${this.prefix}.${value}`;
		return this.translateService.instant(prefixedKey) !== prefixedKey ? prefixedKey : value;
	}
}
